import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home-forty',
  templateUrl: './home-forty.component.html',
  styleUrls: ['./home-forty.component.scss']
})
export class HomeFortyComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
